export default "__VITE_ASSET__C_y1XyVi__"